import { PropsWithChildren } from 'react'
import { Box } from '@grupoboticario/flora-react'

import { brandTheme } from './BrandThemeProvider'

export const WithTheme = ({ children }: PropsWithChildren<{}>) => {
  return <Box className={brandTheme.className}>{children}</Box>
}
